import { API_BASE_URL } from "@/constants";
import { apiClient } from "../apiClient";
import {
  CreateRosterDetailsRes,
  RosterAvailabilityRes,
  RosterEligibilityRes,
} from "@/central-atoms/everest-fleet-pwa/responses";
import { CreateRosterReq } from "@/central-atoms/everest-fleet-pwa/requests";

class RosterFlowService {
  static async createRoster(
    reqBody: CreateRosterReq
  ): Promise<CreateRosterDetailsRes> {
    const response = await apiClient.post(
      `${API_BASE_URL}/driver/roster/create`,
      reqBody
    );
    return response.data;
  }

  static async rosterAvailability(
    type: string
  ): Promise<any> {
    const response = await apiClient.get(
      `${API_BASE_URL}/driver/roster/availability`,
      {
        params: {
          type,
        },
      }
    );
    return response.data;
  }

  static async rosterEligibility(): Promise<any> {
    const response = await apiClient.get(
      `${API_BASE_URL}/driver/roster/eligibility`
    );
    return response.data;
  }
}

export default RosterFlowService;
